import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-ms-history-main-table",
	templateUrl: "./ms-history-main-table.component.html",
	styleUrls: ["./ms-history-main-table.component.css"],
})
export class MsHistoryMainTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateFilters();
	}

	ngOnChanges() {
		this.UpdateFilters();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() lstVisitorPass: any = [];
	@Input() loading: any = false;

	@Output() VisitorPassSelected: EventEmitter<any> = new EventEmitter();

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedVisitorPass: any;

	lstVisitorTypeDesc: any = [];
	lstVisiteeName: any = [];
	lstVisitorReason: any = [];
	lstVisitorStatusDesc: any = [];
	lstAdminName: any = [];
	lstIsOffenderHitDesc: any = [];
	lstIsAliasDesc: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateFilters() {
		this.SelectedVisitorPass = null;

		this.lstVisitorTypeDesc = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.VisitorTypeDesc))).sort();
		this.lstVisiteeName = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.VisiteeName))).sort();
		this.lstVisitorReason = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.VisitorReason))).sort();
		this.lstVisitorStatusDesc = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.VisitorStatusDesc))).sort();
		this.lstAdminName = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.AdminName))).sort();
		this.lstIsOffenderHitDesc = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.IsOffenderHitDesc))).sort();
		this.lstIsAliasDesc = Array.from(new Set(this.lstVisitorPass.map((item: any) => item.IsAliasDesc))).sort();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onRowSelect(val) {
		this.SelectedVisitorPass = val.data;

		this.VisitorPassSelected.emit(this.SelectedVisitorPass);
	}

	onRowUnselect(val) {
		this.SelectedVisitorPass = null;

		this.VisitorPassSelected.emit(this.SelectedVisitorPass);
	}

	////////////////////////////////////////////
}
